export default __webpack_public_path__ + "static/media/poodlFour.2a5b3a67.jpg";